import { Box, Typography, Divider, Chip } from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

function ChangelogLayout({ children, title, date }) {
  return (
    <Box
      sx={{
        ...viewRootTextPrimarySx,
        backgroundColor: 'background.paper',
        borderRadius: 2,
        padding: 3,
        marginBottom: 3,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'space-between',
          marginBottom: 2,
          width: '100%',
          gap: 1,
        }}
      >
        {title && (
          <Typography
            variant='h5'
            component='h2'
            sx={{ fontWeight: 600, flexGrow: 1, textAlign: 'left' }}
          >
            {title}
          </Typography>
        )}
        <Box
          sx={{
            display: 'flex',
            alignItems: { xs: 'center', sm: 'start' },
            justifyContent: { xs: 'center', sm: 'flex-start' },
            gap: 1,
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <Chip
            icon={<CalendarMonth />}
            label={date}
            size='small'
            variant='outlined'
            color='primary'
            sx={{ padding: '6px' }}
          />
        </Box>
      </Box>
      <Divider sx={{ marginBottom: 2 }} />
      {children}
    </Box>
  );
}

export default ChangelogLayout;
